import AddCircleIcon from '@mui/icons-material/AddCircle';
import AddTaskIcon from '@mui/icons-material/AddTask';
// import ListItemIcon from "@mui/material/ListItemIcon";
import ContentCut from '@mui/icons-material/ContentCut';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import PostAddIcon from '@mui/icons-material/PostAdd';
// import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from '@mui/icons-material/Search';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import InputBase from '@mui/material/InputBase';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
// import PlusIconMenu from "./menu/PlusIconMenu";
// import Divider from "@mui/material/Divider";
// import Paper from "@mui/material/Paper";
import MenuList from '@mui/material/MenuList';
import { alpha,styled } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(1),
        width: 'auto',
    },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: '12ch',
            '&:focus': {
                width: '20ch',
            },
        },
    },
}));

export default function HeaderBar({ title }) {
    HeaderBar.propTypes = {
        title: PropTypes.any,
    };
    const [anchorEl, setAnchorEl] = React.useState(null);
    const { i18n } = useTranslation();
    const open = Boolean(anchorEl);
    const handlePlusIconClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handlePlusIconClose = () => {
        setAnchorEl(null);
    };
    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar
                position="static"
                color="inherit"
                elevation={0}
            >
                <Toolbar>
                    <Typography
                        variant="h6"
                        noWrap
                        component="div"
                        sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}
                    >
                        {title}
                    </Typography>
                    <IconButton
                        aria-label="Add"
                        id="add-button"
                        aria-controls={open ? 'plus-icon-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handlePlusIconClick}
                    >
                        <AddCircleIcon sx={{ color: '#5778FF', fontSize: 35 }} />
                    </IconButton>
                    <Menu
                        sx={{ width: 320, maxWidth: '100%' }}
                        id="plus-icon-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handlePlusIconClose}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                    >
                        <MenuList>
                            <MenuItem >
                                <PostAddIcon>
                                    <ContentCut fontSize="small" />
                                </PostAddIcon>
                                <ListItemText className="ms-3">{i18n.t('Projet')}</ListItemText>
                            </MenuItem>
                            <MenuItem>
                                <AddTaskIcon>
                                    <ContentCut fontSize="small" />
                                </AddTaskIcon>
                                <ListItemText className="ms-3">{i18n.t('Tâche')}</ListItemText>
                            </MenuItem>
                            <MenuItem>
                                <PersonAddAltIcon>
                                    <ContentCut fontSize="small" />
                                </PersonAddAltIcon>
                                <ListItemText className="ms-3">{i18n.t('Collaborateur')}</ListItemText>
                            </MenuItem>
                        </MenuList>
                    </Menu>

                    <Search>
                        <SearchIconWrapper>
                            <SearchIcon />
                        </SearchIconWrapper>
                        <StyledInputBase
                            placeholder="Search…"
                            inputProps={{ 'aria-label': 'search' }}
                        />
                    </Search>
                </Toolbar>
            </AppBar>
        </Box>
    );
}
